import { render, staticRenderFns } from "./column_video_list.vue?vue&type=template&id=089afac7&scoped=true"
import script from "./column_video_list.vue?vue&type=script&lang=js"
export * from "./column_video_list.vue?vue&type=script&lang=js"
import style0 from "./column_video_list.vue?vue&type=style&index=0&id=089afac7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089afac7",
  null
  
)

export default component.exports